import { getMolecularCdnServiceConfig } from 'src/feature-app';

const handleErrorInRetrievingExternalConfig = (): null => {
  console.error('Error retrieving Molecular CDN service config provider.');
  return null;
};

export const getMolecularCdnUrl = (): string | null => {
  const molecularCdn = getMolecularCdnServiceConfig();

  if (!molecularCdn) {
    return handleErrorInRetrievingExternalConfig();
  }

  return molecularCdn.urlOrigin + molecularCdn.urlPath;
};
